
import store from '@/store';
import { Conflict } from '@/store/modules/Photos';
import SessionsModule from '@/store/modules/Sessions';
import UploadModule from '@/store/modules/Upload';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const uploadModule = getModule(UploadModule, store);
const sessionsModule = getModule(SessionsModule, store);

export const replaceBus = new Vue();

@Component
export default class ReplaceDialog extends Vue {
    private conflictOverrides: Conflict[] = [];
    private activeConflictOverride = false;

    @Watch('originalConflicts')
    originalConflictsChange() {
        this.conflictOverrides = this.conflictOverrides.filter(
            c => this.originalConflicts.some(oc => oc.conflictId === c.conflictId)
        );
    }

    get originalConflicts() {
        return uploadModule.conflicts;
    }

    get conflicts() {
        return this.originalConflicts.map(conflict => {
            const conflictOverride = this.conflictOverrides.find(c => c.conflictId === conflict.conflictId);
            if (conflictOverride)
                return conflictOverride;

            return conflict;
        })
    }

    get conflictsWithSessions() {
        return this.conflicts.map(conflict => ({
            ...conflict,
            session: sessionsModule.sessions[conflict.sessionId],
        }));
    }

    get nonFinalizationConflicts() {
        return this.conflictsWithSessions.filter(({ session }) => !session.finalizationMode);
    }

    get finalizationConflicts() {
        return this.conflictsWithSessions.filter(({ session }) => session.finalizationMode);
    }

    get dialogOpen() {
        return this.nonFinalizationConflicts.length > 0 && !this.activeConflictOverride && this.finalizationConflicts.length === 0;
    }

    replaceAll() {
        this.conflicts.forEach(conflict => this.replace(conflict));
    }

    addAll() {
        this.conflicts.forEach(conflict => this.add(conflict));
    }

    replace(conflict: Conflict) {
        if ((conflict.conflicted.orderedBy || []).length > 0) {
            (this as any).$vToastify.error({
                title: 'Nie można podmienić.',
                body: 'Zdjęcie zostało kupione.',
            });
            return;
        }

        conflict.resolve(conflict.conflicted.id);
        this.removeConflict(conflict);
    }

    requestConflictOverride(conflict: Conflict) {
        replaceBus.$emit('requestConflictOverride', conflict);
    }

    add(conflict: Conflict) {
        conflict.resolve();
        this.removeConflict(conflict);
    }

    cancel(conflict: Conflict) {
        uploadModule.cancelUpload({ file: conflict.photo.file });
        this.removeConflict(conflict);
    }

    cancelAll() {
        this.conflicts.forEach(conflict => this.cancel(conflict));
    }

    mounted() {
        replaceBus.$on('requestConflictOverride', () => {
            this.activeConflictOverride = true;
        });

        replaceBus.$on('resolveConflictOverride', (conflict: Conflict) => {
            this.conflictOverrides = [
                ...this.conflictOverrides.filter(c => c.conflictId !== conflict.conflictId),
                conflict,
            ];
            this.activeConflictOverride = false;
        });
    }

    async overrideConflict(conflict: Conflict) {
        replaceBus.$emit('requestConflictOverride', conflict);
        // const newConflict = await new Promise<Conflict>(resolve => {
        //     replaceBus.$once('resolveConflictOverride', resolve);
        // });

        // if (newConflict) {
        //     this.conflictOverrides.push(newConflict);
        // }
    }

    private removeConflict(conflict: Conflict) {
        this.conflictOverrides = this.conflictOverrides.filter(
            c => c.conflictId !== conflict.conflictId
        );
        uploadModule.removeConflict(conflict);
    }
}
